import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCzKtYQYhH5k2pMvf3QcaXC5RFkMV4BLGE",
  authDomain: "dreamers-budget-app.firebaseapp.com",
  projectId: "dreamers-budget-app",
  storageBucket: "dreamers-budget-app.firebasestorage.app",
  messagingSenderId: "171299039240",
  appId: "1:171299039240:web:1c06532d69b37270c609bd",
};

const app = initializeApp(firebaseConfig);
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;

if (appCheckSiteKey && typeof window !== "undefined") {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
